import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { FlexRow, FlexColumn, CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Wrapper = styled(FlexColumn)`
    position: relative;
    gap: 32px;
`;
export const Line = styled.div<{ $color?: string; $activeColor?: string; $activeFill?: number; $height?: number }>`
    position: absolute;
    left: 11px;
    top: 10px;
    width: 2px;

    ${({ $height }) => css`
        height: ${$height ? `${$height}px` : `calc(100% - 60px)`};
    `}

    ${({ $activeColor = colorsPalettes.blue[350], $color = colorsPalettes.carbon[100], $activeFill = 100 }) => {
        return css`
            background: linear-gradient(
                to bottom,
                ${$activeColor} 0%,
                ${$activeColor} ${$activeFill}%,
                ${$color} ${$activeFill}%,
                ${$color} 100%
            );
        `;
    }}
`;

export const ItemWrapper = styled(FlexRow)`
    gap: 8px;
`;

export const IconContainer = styled(CenteredFlexRow)`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[400]};
    z-index: 1;
`;

export const Icon = styled.img`
    width: 16px;
    height: 16px;
`;

export const ItemTextContainer = styled(FlexColumn)`
    gap: 4px;
`;

export const ItemTitle = styled(Text)`
    margin: 0;
`;

export const ItemDescription = styled(Text)`
    width: 95%;
    margin: 0;
`;
